module.exports = __webpack_public_path__ + "static/media/hubs.a1bbe41f.svg";